<script setup lang="ts">
  import { useWelcomeStore } from '~/store/welcome';

  defineProps<{
    isCompact?: boolean;
  }>();

  const emit = defineEmits<{ click: [] }>();

  const welcomeStore = useWelcomeStore();

  const progressWidth = computed(() => `${(welcomeStore.cashCollected / welcomeStore.totalCashAvailable) * 100}%`);
  const earnProgress = computed(() => `$${welcomeStore.cashCollected} / $${welcomeStore.totalCashAvailable}`);

  function handleClick() {
    navigateTo('/welcome-offer');
    emit('click');
  }
</script>

<template>
  <div
    class="relative flex h-[72px] p-2.5 items-start justify-between gap-1.5 2xl:gap-2.5 rounded-[10px] bg-white/5 cursor-pointer mb-[15px] hover:outline-1"
    @click="handleClick"
  >
    <NuxtImg
      src="/images/welcome-offer/chest-small-closed.webp"
      format="webp"
      alt="chest image"
      class="mx-auto max-w-12 min-[1800px]:max-w-[58px]"
      :class="isCompact ? 'max-w-12' : ''"
    />
    <div v-if="isCompact" class="absolute bottom-2.5 w-[calc(100%-16px)] h-1 rounded-[10px] bg-white/10">
      <div class="h-full bg-[#0080ff] rounded-[10px]" :style="{ width: progressWidth }" />
    </div>
    <div v-else class="w-full flex flex-col gap-2.5">
      <div class="flex items-center justify-between text-white font-inter gap-0.5 2xl:gap-0">
        <span class="shrink-0 text-sm 2xl:text-base font-semibold leading-[150%]">Welcome offer:</span>
        <span class="shrink-0 text-right text-sm font-medium leading-[150%]">{{ earnProgress }}</span>
      </div>
      <div class="w-full h-2.5 rounded-[10px] bg-white/10 overflow-hidden">
        <div class="h-full bg-[#0080ff] rounded-[10px]" :style="{ width: progressWidth }" />
      </div>
    </div>
  </div>
</template>
